import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { createStore } from "../fefoApi";
import FefoDialog from "./FefoDialog";

interface CreateStoreModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CreateStoreModal: React.FC<CreateStoreModalProps> = ({ isOpen, onClose }) => {
  const [nomeFantasia, setNomeFantasia] = useState("");
  const [endereco, setEndereco] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNomeFantasia("");
      setEndereco("");
      setError(null);
    }
  }, [isOpen]);

  const canSubmit = !isLoading && nomeFantasia.trim() !== "" && endereco.trim() !== "";

  const handleCreateStore = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!canSubmit) return;
    setIsLoading(true);
    setError(null);

    try {
      await createStore({ nomeFantasia: nomeFantasia.trim(), endereco: endereco.trim() });
      toast.success("Loja cadastrada.");
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Erro ao criar loja. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FefoDialog
      isOpen={isOpen}
      title="Cadastrar loja"
      description="A loja entra no mesmo cadastro da tela de Lojas."
      onClose={onClose}
      actions={
        <>
          <button type="button" className="ecoBtn" onClick={onClose} disabled={isLoading}>
            Cancelar
          </button>
          <button type="submit" form="fefo-loja" className="ecoBtn ecoBtn--primary" disabled={!canSubmit}>
            {isLoading ? "Cadastrando..." : "Cadastrar"}
          </button>
        </>
      }
    >
      <form id="fefo-loja" className="fefoForm" onSubmit={handleCreateStore}>
        <div className="ecoField">
          <label htmlFor="fefo-loja-nome">Nome da loja (darkstore)</label>
          <input
            id="fefo-loja-nome"
            className="ecoInput"
            type="text"
            value={nomeFantasia}
            onChange={(e) => setNomeFantasia(e.target.value)}
          />
        </div>
        <div className="ecoField">
          <label htmlFor="fefo-loja-endereco">Endereço</label>
          <input
            id="fefo-loja-endereco"
            className="ecoInput"
            type="text"
            value={endereco}
            onChange={(e) => setEndereco(e.target.value)}
          />
        </div>
        {error ? (
          <p className="fefoError" role="alert">
            {error}
          </p>
        ) : null}
      </form>
    </FefoDialog>
  );
};

export default CreateStoreModal;
